import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { QuestionCircle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useStores } from 'services/useStore';

export interface IInfoButton {
  text: string;
  size?: 'lg' | 'sm';
}

const InfoButton: React.FC<IInfoButton> = observer(({ text, size = 'lg' }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<number>();
  const { api } = useStores();
  const onclick = () => {
    if (value) api.showDialog('info', value);
  };
  useEffect(() => {
    const textId = t('help.' + text);
    if (!Number.isNaN(+textId)) {
      const id = parseInt(textId, 10);
      setValue(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Button variant='info' size={size} onClick={onclick}>
      <QuestionCircle fontSize={38} color='white' />
    </Button>
  );
});
export default InfoButton;
